module.exports = __webpack_public_path__ + "static/go-dawgs-e694795a8e29fa1fbd3eb0659d182317.jpg";